import { render, staticRenderFns } from "./ButtonSet.vue?vue&type=template&id=224f2831&"
import script from "./ButtonSet.vue?vue&type=script&lang=js&"
export * from "./ButtonSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports